import React, { FC } from 'react'
import styles from './Space.module.scss'
import { SpaceProps } from './Space.model'

export const Space: FC<SpaceProps> = ({ children }) => (
  <span className={styles.space}>{children} </span>
)
